import PopupMenuActions from '../../../../shared/popup-menu';
import {PopupMenuAction} from '../../../../shared/popup-menu/types';
import {SVGS} from '../../../../../assets/images';
import React, {useEffect, useState} from 'react';
import {UpdateStatusAbility} from '../../../../../features/schedule/types';
import {IntlShape} from 'react-intl';
import {Lx} from '../../../../../i18n/consts';

interface Props {
    intl: IntlShape,
    approvableHours: number,
    billableHours: number,
    approvedHours: number,
    billedHours: number,
    state: { isApproved: boolean, isBillable: boolean },
    onAddNewShiftClick?: () => Promise<void>,
    onApproveClick?: () => Promise<void>,
    onDisaproveClick?: () => Promise<void>,
    onBillClick?: () => Promise<void>,
    onCancelBillClick?: () => Promise<void>,
    statusChanging: boolean;
    hideApprove?: boolean,
    hideBillable?: boolean,
    approveAbility?: UpdateStatusAbility,
    billableAbility?: UpdateStatusAbility,
}

const ToolActionMenu: React.FC<Props> = (props) => {
    const {
        intl,
        state,
        approvableHours,
        billableHours,
        approvedHours,
        billedHours,
        hideBillable,
        hideApprove,
        approveAbility,
        billableAbility,
        statusChanging
    } = props;
    const [actions, setActions] = useState<Array<PopupMenuAction>>([]);

    const loadActions = () => {
        const temp: Array<PopupMenuAction> = [];
        if (!hideApprove) {
            if (state.isApproved || approvedHours > 0) {
                if (approveAbility?.canCancel) {
                    temp.push({
                        name: intl.formatMessage({id: Lx.Schedule.DISAPPROVE_FORMAT_ALL}, {s: approvedHours}),
                        icon: <SVGS.DisapproveIcon/>,
                        callback: () => Promise.resolve(props.onDisaproveClick?.()),
                        disabled: statusChanging,
                    })
                }
            } else {
                if (approveAbility?.canApply) {
                    temp.push({
                        name: intl.formatMessage({id: Lx.Schedule.APPROVE_ALL_FORMAT}, {s: approvableHours}),
                        icon: <SVGS.ApproveIcon/>,
                        callback: () => Promise.resolve(props.onApproveClick?.()),
                        disabled: statusChanging,
                    })
                }
            }
        }
        if (!hideBillable) {
            if (state.isBillable || billedHours > 0) {
                if (billableAbility?.canCancel) {
                    temp.push({
                        name: intl.formatMessage({id: Lx.Schedule.CANCEL_BILL_FORMAT}, {s: billedHours}),
                        icon: <SVGS.MoneyOffIcon/>,
                        callback: () => Promise.resolve(props.onCancelBillClick?.()),
                        disabled: statusChanging,
                    })
                }
            } else {
                if (billableAbility?.canApply) {
                    temp.push({
                        name: intl.formatMessage({id: Lx.Schedule.BILL_ALL_FORMAT}, {s: billableHours}),
                        icon: <SVGS.MoneyIcon/>,
                        callback: () => Promise.resolve(props.onBillClick?.()),
                        disabled: statusChanging,
                    })
                }
            }
        }
        temp.push({
            name: intl.formatMessage({id: Lx.Schedule.CREATE_NEW_TIMESHIFT_SHIFT}),
            icon: <SVGS.PlusIcon/>,
            callback: () => Promise.resolve(props.onAddNewShiftClick?.())
        })
        setActions(temp);
    }

    useEffect(() => {
        loadActions();
    }, [state, statusChanging])

    useEffect(() => {
        loadActions();
    }, [])

    return (<PopupMenuActions actionIcon={<SVGS.ActionIcon/>} actions={actions} newGen size={'small'}/>)
}

export default ToolActionMenu
